module.exports = "/assets/7b90de14b8d4b1817ae1dd306dbb235c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/WS.png
// module id = 3090
// module chunks = 0